import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedStyle = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.94876 18.1539L12.24 4.23558L19.9331 5.02891L21.4772 11.1564C21.693 12.0129 21.5823 12.9191 21.1666 13.6985L17.2696 21.005C16.6519 22.163 15.2109 22.5987 14.0551 21.9769L6.94876 18.1539Z"
          fill="url(#paint0_linear_28_12)"
        />
        <g filter="url(#filter0_di_28_12)">
          <path
            d="M3.29285 10.8953L10.7446 3.38233C11.2597 2.86297 11.9609 2.57084 12.6924 2.57083L18.1336 2.57074C19.6488 2.57071 20.8772 3.79902 20.8772 5.31422L20.8772 10.7687C20.8772 11.4924 20.5912 12.1868 20.0815 12.7007L12.6363 20.207C11.5662 21.2859 9.82303 21.2895 8.74853 20.215L3.30077 14.7672C2.23246 13.6989 2.22892 11.9679 3.29285 10.8953Z"
            fill="url(#paint1_linear_28_12)"
          />
        </g>
        <g filter="url(#filter1_di_28_12)">
          <path
            d="M18.0706 6.86629C18.0706 7.73243 17.3685 8.43458 16.5023 8.43458C15.6362 8.43458 14.934 7.73243 14.934 6.86629C14.934 6.00015 15.6362 5.298 16.5023 5.298C17.3685 5.298 18.0706 6.00015 18.0706 6.86629Z"
            fill="#5E178A"
          />
        </g>
        <path
          d="M11.3891 9.54904C11.2206 9.0936 10.5764 9.0936 10.4079 9.54905V9.54905C9.98401 10.6946 9.08084 11.5977 7.93532 12.0216V12.0216C7.47987 12.1902 7.47987 12.8343 7.93532 13.0029V13.0029C9.08084 13.4267 9.98401 14.3299 10.4079 15.4754V15.4754C10.5764 15.9309 11.2206 15.9309 11.3891 15.4754V15.4754C11.813 14.3299 12.7162 13.4267 13.8617 13.0029V13.0029C14.3172 12.8343 14.3172 12.1902 13.8617 12.0216V12.0216C12.7162 11.5977 11.813 10.6946 11.3891 9.54904V9.54904Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_di_28_12"
            x="2.49722"
            y="2.57074"
            width="22.6466"
            height="22.7144"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="2.56" dy="2.56" />
            <feGaussianBlur stdDeviation="0.853333" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_28_12" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_28_12" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.426667" dy="0.853333" />
            <feGaussianBlur stdDeviation="0.16" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_28_12" />
          </filter>
          <filter
            id="filter1_di_28_12"
            x="14.1874"
            y="4.12467"
            width="3.88325"
            height="6.01658"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-0.426667" dy="-0.853333" />
            <feGaussianBlur stdDeviation="0.16" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_28_12" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_28_12" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3.41333" />
            <feGaussianBlur stdDeviation="0.853333" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0" />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_28_12" />
          </filter>
          <linearGradient
            id="paint0_linear_28_12"
            x1="24.5251"
            y1="7.68092"
            x2="11.6271"
            y2="7.47859"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.337213" stopColor="#841DC4" />
            <stop offset="1" stopColor="#451265" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_28_12"
            x1="20.8981"
            y1="2.59169"
            x2="6.01168"
            y2="17.4781"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D899FF" />
            <stop offset="1" stopColor="#841DC4" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedStyle
